import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { FormControlOption } from '../../../definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'risk-profil-company-fourth-part-form',
    templateUrl: './risk-profil-company-fourth-part-form.component.html',
    styleUrls: ['./risk-profil-company-fourth-part-form.component.scss'],
    standalone: false
})
export class RiskProfilCompanyFourthPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options1: FormControlOption[] = [
    { value: 'LESS_THAN_250K', label: 'Inférieur à 250k€' },
    { value: 'BETWEEN_250K_AND_500K', label: 'Entre 250k et 500k€' },
    { value: 'BETWEEN_500K_AND_1000K', label: 'Entre 500k et 1M€' },
    { value: 'BETWEEN_1000K_AND_2500K', label: 'Entre 1M€ et 2.5M€' },
    { value: 'GREATER_THAN_2500K', label: 'Supérieur à 2.5M€' },
  ];
  options2: FormControlOption[] = [
    { value: 'LESS_THAN_THREE_YEARS', label: '< 3 ans' },
    { value: 'MORE_THAN_THREE_YEARS', label: '> 3 ans' },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
